import { waitForDOMContentLoaded } from "./async-utils";
import configs from "./configs";

// Node these should be synchronized with the top of shared.scss
// TODO: XMUSEUM, Object 相关文字颜色和按钮背景 
const DEFAULT_ACTION_COLOR = "#BBBBBB";
const DEFAULT_ACTION_COLOR_LIGHT = "#ADADAD";

const DEFAULT_COLORS = {
  "action-color": DEFAULT_ACTION_COLOR,
  "action-label-color": DEFAULT_ACTION_COLOR,
  "action-color-disabled": DEFAULT_ACTION_COLOR_LIGHT,
  "action-color-highlight": DEFAULT_ACTION_COLOR_LIGHT,
  "action-text-color": "#FFFFFF",
  "action-subtitle-color": "#F0F0F0",
  "notice-background-color": "#868686",//TODO: XMUSEUM 修改颜色
  "notice-text-color": "#FFFFFF",
  "favorited-color": "#FFC000",
  "text-color": "#000000",//TODO: XMUSEUM 添加text-color
  "nametag-color": "#000000",
  "nametag-volume-color": "#7ED320",
  "nametag-text-color": "#FFFFFF",
  "nametag-border-color": "#7ED320",
  "nametag-border-color-raised-hand": "#FFCD74"
};

function getThemeColor(name) {
  const themeId = window.APP?.store?.state?.preferences?.theme;

  const theme =
    (themeId && configs.APP_CONFIG?.theme?.themes?.find(theme => theme.id === themeId)) ||
    configs.APP_CONFIG?.theme?.themes?.find(theme => theme.default === true);
  if (theme?.variables?.[name]) {
    return theme.variables[name];
  }

  return DEFAULT_COLORS[name];
}

function activateTheme() {
  const actionColor = getThemeColor("action-color");
  const actionHoverColor = getThemeColor("action-color-highlight");
  //TODO: XMUSEUM 添加text-color
  const textColor = getThemeColor("text-color");

  // //TODO: XMUSEUM 将颜色统一更改为text-color
  if (document.querySelector("#rounded-text-button")) {
    // NOTE, using the object-based {} setAttribute variant in a-frame
    // seems to not work in Firefox here -- the entities with the mixins are not
    // updated.
    document
      .querySelector("#rounded-text-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${textColor}; textColor: ${textColor}; backgroundColor: ${actionColor}; backgroundHoverColor: ${actionHoverColor};`
      );

    document
      .querySelector("#rounded-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${textColor}; textColor: ${textColor}; backgroundColor: ${actionColor}; backgroundHoverColor: ${actionHoverColor};`
      );

    document
      .querySelector("#rounded-text-action-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${textColor}; textColor: ${textColor}; backgroundColor: ${actionColor}; backgroundHoverColor: ${actionHoverColor}`
      );

    document
      .querySelector("#rounded-action-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${textColor}; textColor: ${textColor}; backgroundColor: ${actionColor}; backgroundHoverColor: ${actionHoverColor}`
      );
  }
}

const onStoreChanged = (function() {
  let themeId;
  return function onStoreChanged() {
    const newThemeId = window.APP?.store?.state?.preferences?.theme;
    if (themeId !== newThemeId) {
      themeId = newThemeId;
      activateTheme();
    }
  };
})();

waitForDOMContentLoaded().then(() => {
  if (configs.APP_CONFIG && configs.APP_CONFIG.theme && configs.APP_CONFIG.theme["dark-theme"]) {
    document.body.classList.add("dark-theme");
  } else {
    document.body.classList.add("light-theme");
  }
  activateTheme();
  window.APP?.store?.addEventListener("statechanged", onStoreChanged);
});

function applyThemeToTextButton(el, highlighted) {
  el.setAttribute(
    "text-button",
    "backgroundColor",
    highlighted ? getThemeColor("action-color-highlight") : getThemeColor("action-color")
  );
  el.setAttribute(
    "text-button",
    "backgroundHoverColor",
    highlighted ? "#aaa" : getThemeColor("action-color-highlight")
  );
}

export { applyThemeToTextButton, getThemeColor };
